import dynamic from 'next/dynamic'

export const DevMenu = dynamic(() => import('./dev-menu'), { ssr: false })
